export class MachineList
{
    id: number;
    shortname : string ;
    serialnumber :string;
    location : string ;
    state : string
    client : string; 

}
